import { curveStep } from 'd3-shape';
import { Curve } from './curve';
export const HVH = (options, context) => {
    return Curve(Object.assign({ curve: curveStep }, options), context);
};
HVH.props = Object.assign(Object.assign({}, Curve.props), { defaultMarker: 'hvh' });
//# sourceMappingURL=hvh.js.map